export default __webpack_public_path__ + "static/media/spid-idp-spiditalia.3773886e.png";